export default "__VITE_ASSET__DGkEdjIl__"